export const ROOT = "/";
export const PORTFOLIOLIST = "/portfolioList";
export const PORTFOLIODETAIL = "/portfolioDetail";
export const WALFAREDETAIL = "/walfareDetail";